(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambassador-signup-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__responsiveIframe) return;
    window.__responsiveIframe = true;

    function parseHeight(data, depth) {
      if (data == null || depth > 4) return null;
      if (typeof data === 'number' && isFinite(data) && data > 50) return data;
      if (typeof data === 'string') {
        var trimmed = data.trim();
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          try { return parseHeight(JSON.parse(trimmed), depth + 1); } catch (e) { return null; }
        }
        var parsed = parseFloat(trimmed);
        return parsed > 50 ? parsed : null;
      }
      if (Array.isArray(data)) {
        if (data[0] === 'iFrameSizer' || data[0] === 'setHeight') return parseHeight(data[1], depth + 1);
        return null;
      }
      if (typeof data === 'object') {
        var raw = data.height || data.iframeHeight || data.scrollHeight;
        if (raw == null && data.payload) raw = data.payload.height;
        return parseHeight(raw, depth + 1);
      }
      return null;
    }

    function bind(frame) {
      if (frame.getAttribute('data-responsive-iframe-bound') === 'true') return;
      frame.setAttribute('data-responsive-iframe-bound', 'true');
      if (frame.getAttribute('data-auto-height') !== 'true') return;

      var origin = '';
      try {
        origin = new URL(frame.getAttribute('src'), window.location.href).origin;
      } catch (e) {}

      window.addEventListener('message', function (event) {
        if (event.source !== frame.contentWindow) return;
        if (origin && event.origin !== origin) return;
        var height = parseHeight(event.data, 0);
        if (!height) return;
        var buffer = parseInt(frame.getAttribute('data-height-buffer') || '0', 10) || 0;
        frame.style.setProperty('--iframe-height', Math.round(height + buffer) + 'px');
      });
    }

    function init() {
      document.querySelectorAll('[data-responsive-iframe]').forEach(bind);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-iframe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__responsiveIframe) return;
    window.__responsiveIframe = true;

    function parseHeight(data, depth) {
      if (data == null || depth > 4) return null;
      if (typeof data === 'number' && isFinite(data) && data > 50) return data;
      if (typeof data === 'string') {
        var trimmed = data.trim();
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          try { return parseHeight(JSON.parse(trimmed), depth + 1); } catch (e) { return null; }
        }
        var parsed = parseFloat(trimmed);
        return parsed > 50 ? parsed : null;
      }
      if (Array.isArray(data)) {
        if (data[0] === 'iFrameSizer' || data[0] === 'setHeight') return parseHeight(data[1], depth + 1);
        return null;
      }
      if (typeof data === 'object') {
        var raw = data.height || data.iframeHeight || data.scrollHeight;
        if (raw == null && data.payload) raw = data.payload.height;
        return parseHeight(raw, depth + 1);
      }
      return null;
    }

    function bind(frame) {
      if (frame.getAttribute('data-responsive-iframe-bound') === 'true') return;
      frame.setAttribute('data-responsive-iframe-bound', 'true');
      if (frame.getAttribute('data-auto-height') !== 'true') return;

      var origin = '';
      try {
        origin = new URL(frame.getAttribute('src'), window.location.href).origin;
      } catch (e) {}

      window.addEventListener('message', function (event) {
        if (event.source !== frame.contentWindow) return;
        if (origin && event.origin !== origin) return;
        var height = parseHeight(event.data, 0);
        if (!height) return;
        var buffer = parseInt(frame.getAttribute('data-height-buffer') || '0', 10) || 0;
        frame.style.setProperty('--iframe-height', Math.round(height + buffer) + 'px');
      });
    }

    function init() {
      document.querySelectorAll('[data-responsive-iframe]').forEach(bind);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
